import React, { useEffect, useState } from "react";
import { getCoinBalance } from "../../utils/services/smartContract";

import "./TokenCard.scss";
import { getBlockchainType } from "../../utils/services/auth";
import { getCoreumTokenBalance } from "../../utils/services/coreum";
import { getXRDTokenBalance } from "../../utils/services/radix";

interface TokenCardProps {
  name: string;
  abb: string;
  logo: string;
  size: string;
  style: React.CSSProperties;
  minBalance?: number;
  setSelectedCoin: (name: string) => void;
}

const TokenCard: React.FC<TokenCardProps> = ({
  name,
  abb,
  logo,
  size,
  style,
  minBalance = 0,
  setSelectedCoin,
}) => {
  const [tokenBalance, setTokenBalance] = useState<number>(0);
  useEffect(() => {
    let mounted = true;
    (async () => {
      let balance;
      switch (getBlockchainType()) {
        case "Coreum":
          balance = await getCoreumTokenBalance();
          break;
        case "Radix":
          balance = await getXRDTokenBalance()
          break;
        default:
          balance = await getCoinBalance(name);
      }
      mounted && setTokenBalance(Number(balance));
    })();
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div
      className="TokenCard"
      style={
        tokenBalance > minBalance
          ? { width: "100%" }
          : { ...style, width: "100%" }
      }
      onClick={() => {
        tokenBalance >= minBalance && setSelectedCoin(name);
        // setSelectedCoin(name); // to be removed
      }}
    >
      <div className="info">
        <img
          src={logo}
          style={size === "small" ? { width: "20px", height: "20px" } : {}}
          alt="coinLogo"
        />
        {size !== "small" && <p className="name">{name}</p>}
      </div>
      <div className="balance">
        {" "}
        {tokenBalance || 0} {abb}{" "}
      </div>
    </div>
  );
};

export default TokenCard;
